import { render, staticRenderFns } from "./majorQuery.vue?vue&type=template&id=0c001625&scoped=true&"
import script from "./majorQuery.vue?vue&type=script&lang=js&"
export * from "./majorQuery.vue?vue&type=script&lang=js&"
import style0 from "./majorQuery.vue?vue&type=style&index=0&id=0c001625&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c001625",
  null
  
)

export default component.exports